import React from 'react'

import VScroll from "../../../../scrolling/custom-v-scroll/v-scroll"
import {COVER_SELECTOR_MENU_HEIGHT} from "../../selector-popover"
import AttachmentsCollection from "../../../../../model2/attachment/attachments"
import {Cover} from "../../../../../model2/task/properties/cover"

// @ts-ignore
import AttachmentsListByType from "../../../../files/attachments-list/list-by-type"
import {CoverType} from "../../../cover-type";
import {AttachFileMode} from "../../../../files/const";

type Props = {
    attachments?    : AttachmentsCollection

    onCoverSelected : {(cover:Cover):void}
}

const debug = false
// const debug = "CoverSelectorAttachments"

export default function CoverSelectorAttachments (props:Props) {

    const onSelect = (attachment:any) => {
        debug && console.log(debug, 'onSelect', attachment)

        const url = attachment.thumbnailUrl(1200)
        props.onCoverSelected(new Cover({
            type: CoverType.ATTACHMENT,
            url : url
        }))
    }

    const styles = {
        height: `calc(100% - ${COVER_SELECTOR_MENU_HEIGHT}px)`
    }

    const attachmentsCollection = new AttachmentsCollection(props.attachments?.withPreview)

    debug && console.log(debug, 'render', props)

    return (
        <div className="cover-attachments" style={styles}>
            <VScroll containerClass="p-l-15 p-t-20 p-r-15 p-b-20">

                {/*<div className="flex-row-left-center ui5-txt-not-important-small h-30 p-b-10">1500+ pixels images are recommended</div>*/}

                {attachmentsCollection.isEmpty &&
                    <div className="flex-row-center-center">
                        <div className="ui5-txt-no-accent-small">No image attachments found</div>
                    </div>}

                <AttachmentsListByType mode={AttachFileMode.VIEW}
                                       attachments  = {attachmentsCollection}
                                       onPreview    = {onSelect}/>
            </VScroll>
        </div>
    )
}
